/* eslint-disable camelcase */
export enum MenusBehaviourTypes {
  OPEN_SIDEBAR = '@menus_behaviour/OPEN_SIDEBAR',
  CLOSE_SIDEBAR = '@menus_behaviour/CLOSE_SIDEBAR',
  OPEN_FEEDBACK_MODAL = '@menus_behaviour/OPEN_FEEDBACK_MODAL',
  CLOSE_FEEDBACK_MODAL = '@menus_behaviour/CLOSE_FEEDBACK_MODAL',
  OPEN_CHATBOT_ASSISTANT = '@menus_behaviour/OPEN_CHATBOT_ASSISTANT',
  CLOSE_CHATBOT_ASSISTANT = '@menus_behaviour/CLOSE_CHATBOT_ASSISTANT',
}

export interface MenusBehaviourData {
  sideBar: boolean;
  feedbackModal: boolean;
  pathname: string;
  chatbotAssistant: boolean;
}

export interface MenusBehaviourState {
  menus_behaviour: MenusBehaviourData;
}
